export default {
    getAllCommercialAgents: () => {
        return {
            url: '/simulationenr/commercialAgent',
            method: 'GET'
        };
    },
    getCommercialAgentsDetails: commercialAgentId => {
        return {
            url: '/simulationenr/commercialAgent/:commercialAgentId',
            method: 'GET',
            route_params: {
                commercialAgentId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/simulationenr/data/CommercialAgents/api.js